import { InappBrowser, type InappBrowserType } from '@constants'

/* Threads 排在 Instagram 前面：兩者同屬 Meta，UA 是否互相包含未經實機確認，而它們的開關可以各自開關 */
const NAMED_BROWSER_UA_PATTERNS = [
  { browser: InappBrowser.LINE, pattern: /Line\// },
  { browser: InappBrowser.FACEBOOK, pattern: /FBAN|FBAV|MetaIAB/ }, /* 新版 Android FB 改帶 MetaIAB，不再帶 FBAN/FBAV */
  { browser: InappBrowser.THREADS, pattern: /Barcelona|Threads/ }, /* iOS 帶的是內部代號 Barcelona */
  { browser: InappBrowser.INSTAGRAM, pattern: /Instagram/ },
  { browser: InappBrowser.TIKTOK, pattern: /musical_ly|trill_|aweme[/_]/ }, /* aweme 是抖音 */
  { browser: InappBrowser.WECHAT, pattern: /MicroMessenger\// },
  { browser: InappBrowser.TWITTER, pattern: /Twitter for iPhone|TwitterAndroid/ },
  { browser: InappBrowser.LINKEDIN, pattern: /\[LinkedInApp\]/ },
  { browser: InappBrowser.KAKAOTALK, pattern: /KAKAOTALK[/ ]/i }, /* 大小寫與分隔都有兩種：Android 是 `KAKAOTALK `、iOS 是 `KakaoTalk/` */
  { browser: InappBrowser.SNAPCHAT, pattern: /Snapchat\// },
  { browser: InappBrowser.WEIBO, pattern: /Weibo \(/ }, /* 不用裸字面，會誤中含該字樣的一般 UA */
] as const

/* 只認具名 App；其餘一律視為一般瀏覽器——誤攔正常瀏覽器的代價高於漏攔 */
export const detectInappBrowser = (userAgent: string): InappBrowserType =>
  NAMED_BROWSER_UA_PATTERNS.find(({ pattern }) => pattern.test(userAgent))?.browser ?? InappBrowser.NONE
